module.exports = __webpack_public_path__ + "img/whatsapp-1.d4e4193d.svg";